import { getLogger } from "@/lib/logger";
import { handleSystemApiError } from "@/lib/queryClient";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { closeGlobalErrorDialog } from "./GlobalErrorDialog/actions";

export function ErrorComponent({ error }: ErrorComponentProps) {
  getLogger().error("エラーが発生しました。", error);
  useEffect(() => {
    /**
     * NOTE: Component / API で発生したエラーの場合も含めてハンドリングしている
     * → 特に useSuspenseQuery でエラーが発生した場合は tanstack の router に渡ってくる
     * → （<Suspense > 等でエラーを吸収されてしまうため）
     * → つまり、QueryClient で適用している onError は適用されない
     */
    handleSystemApiError({ error, isHistoryBackIfPossible: true });
    return () => closeGlobalErrorDialog();
  }, [error]);
}
